import { memo } from "../../../../../../../motion-utils@12.9.4/external/motion-utils/dist/es/memo.mjs";
const supportsScrollTimeline = /* @__PURE__ */ memo(() => window.ScrollTimeline !== void 0);
export {
  supportsScrollTimeline
};
